/**
 * Parse ?address= or ?property_address= for a personalized home hero.
 * Hyphens and plus signs become spaces; words are title-cased for display.
 *
 * @param {string} search - location.search (e.g. "?address=123-main-st")
 * @returns {string | null} Display string, or null if missing/invalid
 */
export function parseHeroAddressParam(search) {
  if (!search || typeof search !== "string") return null;
  const q = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(q);
  const raw = params.get("address") || params.get("property_address");
  if (!raw || !String(raw).trim()) return null;
  try {
    const decoded = decodeURIComponent(String(raw).trim()).replace(/\+/g, " ");
    const spaced = decoded.replace(/-/g, " ").replace(/\s+/g, " ").trim();
    if (!spaced) return null;
    return spaced.replace(/\b([a-z])/gi, (m) => m.toUpperCase());
  } catch {
    return null;
  }
}
